/** Fingerprint e metadados de dispositivo (alinhado ao CRM legado). */

export function getDeviceFingerprint(): string {
  let deviceId = localStorage.getItem('crm_device_id')
  if (!deviceId) {
    deviceId = crypto.randomUUID()
    localStorage.setItem('crm_device_id', deviceId)
  }

  const screenRes = `${window.screen.width}x${window.screen.height}`
  const userAgent = navigator.userAgent
  const language = navigator.language
  const raw = `${deviceId}|${userAgent}|${screenRes}|${language}`
  return btoa(raw).substring(0, 100)
}

export function getDeviceName(): string {
  const ua = navigator.userAgent
  if (ua.includes('Windows')) return 'Windows PC'
  if (ua.includes('iPhone')) return 'iPhone'
  if (ua.includes('Android')) return 'Android Device'
  if (ua.includes('Macintosh')) return 'MacBook/iMac'
  if (ua.includes('Linux')) return 'Linux PC'
  return 'Unknown Device'
}

export function getLoginTelemetry() {
  return {
    screenResolution: `${window.screen.width}x${window.screen.height}`,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    language: navigator.language,
  }
}

export function encodeLoginIntentTime(): string {
  return btoa(String(Date.now()))
}

export function decodeLoginIntentTime(encoded: string): number | null {
  try {
    const ms = parseInt(atob(encoded), 10)
    return Number.isFinite(ms) ? ms : null
  } catch {
    return null
  }
}

/** Intent expirado (>20h) ou inválido — limite da API é 24h. */
export function isLoginIntentStale(encoded: string | undefined): boolean {
  if (!encoded) return true
  const intentMs = decodeLoginIntentTime(encoded)
  if (intentMs == null) return true
  return Math.abs(Date.now() - intentMs) > 20 * 60 * 60 * 1000
}

export async function getBrowserLocation(): Promise<{ lat: number; lon: number } | undefined> {
  if (!navigator.geolocation) return undefined

  return new Promise((resolve) => {
    navigator.geolocation.getCurrentPosition(
      (pos) => resolve({ lat: pos.coords.latitude, lon: pos.coords.longitude }),
      () => resolve(undefined),
      { timeout: 4000, maximumAge: 60_000 },
    )
  })
}
